import { OverlayModule } from '@angular/cdk/overlay';
import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from '@angular/core';

import { DsModal, DsModalContent } from '@frontend/ui/modal';
import { ElementKeyDirective } from '@frontend/vanilla/core';
import { QuickDepositFeatureComponent } from '@payments/quickdeposit-feature';

import { QuickDepositResponsiveComponent } from './quick-deposit-responsive.component';

@Component({
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [OverlayModule, ElementKeyDirective, QuickDepositFeatureComponent, DsModal, DsModalContent],
    selector: 'lh-quick-deposit-responsive-lib',
    templateUrl: './quick-deposit-lib.component.html',
    styleUrl: '../../../../../../themepark/themes/whitelabel/components/quick-deposit-lib/styles.scss',
    encapsulation: ViewEncapsulation.None,
})
export class QuickDepositLibraryComponent extends QuickDepositResponsiveComponent implements OnInit {
    override async ngOnInit(): Promise<void> {
        await super.ngOnInit();
    }
}
